import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  informativeText: ({ spacing }) => css`
    margin: ${spacing.md} 0;
  `,
})

export { useStyles }
